/**
 * 考试作业
 */
import request from "@/utils/request";
import { objCoverFormData, postForm } from "@/utils/form";

/*
根据关键字获取机构信息
*/
export const GetOrganInfoByKeyword = (params) => {
    return request({
        method: "POST",
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        url: "/Api/Organ/GetOrganInfoByKeyword",
        data: JSON.stringify(params)
    });
};

/*
根据关键字获取机构用户组信息
*/
export const GetOrganLevelInfo = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetOrganAllType",
        headers: { "Content-Type": "multipart/form-data" },
        data: objCoverFormData(params)
    });
};

// 获取机构管理员
export const GetOrganManage = (params) => {
    return request({
        method: "POST",
        url: "/Website/User/GetOrganManage",
        data: params
    });
};

// 保存机构管理员
export async function SaveManager(params) {
    const { pwd, ...otherProps } = params || Object.create(null)
    return request({
        method: "POST",
        url: "/Website/User/SaveManager",
        data: otherProps
    });
}

// 删除管理员信息
export async function DeleteManager(params) {
    return request({
        method: "POST",
        url: "/Api/Organ/DeleteManager",
        data: objCoverFormData(params)
    });
}

// 获取机构用户
export const GetOrganUser = (params) => {
    return request({
        method: "POST",
        url: "/Website/User/GetOrganUser",
        data: params
    });
};

// 获取机构审核用户
export const GetOrganApplyUser = (params) => {
    return request({
        method: "POST",
        url: "/Website/User/GetOrganApplyUser",
        data: params
    });
};

// 审核用户申请-通过
export function AuditUserApplyPass(params) {
    return postForm("/Website/User/AuditUserApplyPass", params);
}

// 审核用户申请-驳回
export function AuditUserApplyReject(params) {
    return postForm("/Website/User/AuditUserApplyReject", params);
}

// 新增机构用户
export const AddOrganUser = (params) => {
    return request({
        method: "POST",
        url: "/Website/User/AddOrganUser",
        data: params
    });
};

// 编辑机构用户
export const EditOrganUser = (params) => {
    return request({
        method: "POST",
        url: "/Website/User/EditOrganUser",
        data: params
    });
};

// 删除前台用户
export async function DeleteOrganUser(params) {
    return request({
        method: "POST",
        url: "/Api/User/DeleteUser",
        data: objCoverFormData(params)
    });
}

// 重置密码
export const ResetPassword = (params) => {
    return request({
        method: "POST",
        url: "/Website/User/ResetPassword",
        data: objCoverFormData(params)
    });
};

// 修改密码（管理员）
export const ResetManagePassword = (params) => {
    return request({
        method: "POST",
        url: "/Website/User/ResetManagePassword",
        params
    });
};

// 新增机构教师
export function addOrgTeacher (params) {
    const { pwd, ...otherProps } = params || Object.create(null)
    return request({
        method: "POST",
        url: "/Website/User/SaveTeacher",
        data: otherProps
    });
}
